import React, { useState } from 'react';
import Modal from '../../../Modal';
import messages from './messages';
import piwik from '../../../../services/analytics';
import { eventTags } from '../../../../services/analytics/tags';
import useConnect from './hooks';

const ModalNpsConsent = () => {
  const [open, setOpen] = useState(true);
  const { onYes, onNo } = useConnect();
  const isNpsModal = true;
  return (
    <Modal
      name="nps-modal"
      isNpsModal={isNpsModal}
      actions={[
        {
          content: messages.yes,
          name: 'yes',
          onClick: () => {
            piwik.trackEvent(eventTags.nps_confirm_consent);
            onYes();
            setOpen(false);
          },
          variant: 'outlined',
        },
        {
          content: messages.no,
          name: 'no',
          onClick: () => {
            piwik.trackEvent(eventTags.nps_deny_consent);
            onNo();
            setOpen(false);
          },
          variant: 'outlined',
        },
      ]}
      content={messages.content}
      open={open}
      title={{
        content: messages.title,
      }}
    />
  );
};

export default ModalNpsConsent;
